﻿import rg4js from 'raygun4js';

import type { IErrorLoggingUser } from '@/plugins/raygun/i-error-logging-user';

// Changes here need to be replicated in MVC, ReLeasedWebRaygunSink.cs

function applyErrorLoggingSettings (buildNumber: string, tenantScopeName: string, appEnvironmentRegion: string): void {
  applySensitiveDataFilter();
  setVersion(buildNumber);
  setTags(tenantScopeName, appEnvironmentRegion);
}

function applySensitiveDataFilter () {
  rg4js('filterSensitiveData', [/.*password$/, 'ConfirmationCode']);
}

function setVersion (appVersion: string): void {
  rg4js('setVersion', appVersion)
}

function setTags (tenantScopeName: string, appEnvironmentRegion: string): void {
  const tags: string[] = []

  if (tenantScopeName) {
    tags.push(`Instance:${tenantScopeName}`);
  }

  if (appEnvironmentRegion) {
    tags.push(`Region:${appEnvironmentRegion}`);
  }

  rg4js('withTags', tags);
}


function setErrorLoggingUser (user: IErrorLoggingUser): void {
  rg4js('setUser', {
    identifier: user.globalIdentifier,
    isAnonymous: false,
    email: user.emailAddress,
    fullName: `${user.firstName} ${user.lastName}`,
    firstName: user.firstName
  });
}

function clearErrorLoggingUser (): void {
  rg4js('getRaygunInstance').resetAnonymousUser();
}

export default {
  applyErrorLoggingSettings,
  setErrorLoggingUser,
  clearErrorLoggingUser
};
